import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { logger } from "shared/logger/logger";

const NotificationContext = createContext();

export const useNotification = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotification must be used within a NotificationProvider');
  }
  return context;
};

export const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);

  const fetchNotifications = useCallback(async () => {
    try {
      // TODO: replace with real API call when endpoint is ready
      // const data = await fetchData('/notifications/list/');
      setNotifications([]);
    } catch (error) {
      logger.error('Erreur lors du chargement des notifications', error);
    }
  }, []);

  useEffect(() => {
    fetchNotifications();
  }, [fetchNotifications]);

  // TODO: WebSocket integration — reconnect with exponential backoff
  // Disabled pending backend readiness. See notifications.ws.js for draft.

  return (
    <NotificationContext.Provider value={{ notifications, setNotifications }}>
      {children}
    </NotificationContext.Provider>
  );
};
